import React from "react";
import {FormHelperText} from "@mui/material";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Grid from "@mui/material/Grid/Grid";

export default (data, key) => {
    return (
        <Grid item md={12} xs={12} key={key} className={data.classList}>
            <FormControl fullWidth error={data.error ? true : false}>
                <FormLabel component="legend">{data.headerName}{data?.inputProps?.required ? '*' : ''}</FormLabel>
                <RadioGroup aria-label={data.headerName} name={data.name} value={data.value} onChange={data.handleChange}>
                    {data.items.map((item, ind) => (<FormControlLabel key={ind} value={item.value} control={<Radio inputProps={data.inputProps || {}}/>} label={item.label} />))}
                </RadioGroup>
                {/*<TemplateArray key={key} data={data} onCallback={data.onCallback} />*/}
                {data.error && (<FormHelperText>{data.error}</FormHelperText>)}
            </FormControl>
        </Grid>
       )
}